import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../HandleHttpErrors";
import SearchableDropdownMulti from "../shared/SearchableDropdownMulti";
//import { useMoamadContext } from "../shared/context/MoamadContext";
const baseURL = process.env.REACT_APP_API_JOBS;

const MemberRep = () => {
  // State for the selected year
  const [members, setMembers] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const [memberId, setmemberId] = useState("");
  const [memberValue, setMemberValue] = useState(null);
  //const [memberRep, setMemberRep] = useState([]);
  const [memberRep, setMemberRep] = useState([]);
  const axiosPrivate = useAxiosPrivate("application/json");
  let history = useNavigate();
  useEffect(() => {
    document.body.classList.add("accountBodyColor");
    // Clean up function to remove the class when the component unmounts
    return () => {
      document.body.classList.remove("accountBodyColor");
    };
  }, []);
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getMembers = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "memberlist/", {
          signal: controller.signal,
        });
        setMembers(response.data);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };

    getMembers();
  }, []);

  const getMemberRep = async () => {
    let isMounted = true;
    const controller = new AbortController();
    const getMembereem = async () => {
      try {
        const response = await axiosPrivate.get(
          baseURL + "bhinamemberrep/?member_id=" + memberId,
          {
            signal: controller.signal,
          }
        );
        if (isMounted) {
          setMemberRep(response.data.sort((a, b) => b.id - a.id));
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    getMembereem();
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  };

  const handleClickButton = (event) => {
    getMemberRep();
    // You can fetch data based on the selected year here
  };

  return (
    <div>
      <h2 style={{ textAlign: "center", color: "white" }}>
        דו"ח השתפפות חברים בישיבות
        {memberRep
          ? memberRep.length > 0
            ? memberRep[0].user__username
            : ""
          : ""}
      </h2>

      <form>
        <div style={{ textAlign: "center" }}>
          <br />
          <Row>
            <Col>בחירת חבר: </Col>
            <Col sm="8" md={{ size: 3, offset: 0 }}>
              <SearchableDropdownMulti
                options={members}
                label="first_name"
                label2="last_name"
                label3="ignore"
                id="id"
                other="last_name "
                selectedVal={memberValue}
                handleChange={(val, id) => {
                  setMemberValue(val);
                  setmemberId(id);
                }}
                //handleChange={handleDDSChange}
                inputProps={{ autocomplete: "off" }}
              />
            </Col>
          </Row>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleClickButton}
          >
            חפש
          </button>
        </div>
      </form>
      <div style={{ marginTop: "20px", backgroundColor: "rgb(200, 200, 200)" }}>
        <center>
          {" "}
          <h2>השתתפות {memberRep[0]?.member_name} בישיבות</h2>
        </center>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "black",
            fontWeight: "bold",
          }}
        >
          <table>
            <thead>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <th
                  className="padding10-td"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  מזהה
                </th>
                <th
                  className="padding10-td"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "20px",
                    textAlign: "center",
                  }}
                >
                  מספר הישיבה
                </th>

                <th
                  className="padding10-td"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  תאריך עריכת הישיבה
                </th>
                <th
                  className="padding10-td"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  מס המכרז
                </th>
                <th
                  className="padding10-td"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  תאור המכרז
                </th>
                <th
                  className="padding10-td"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  תפקיד
                </th>
                <th
                  className="padding10-td"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  נוכח?
                </th>
              </tr>
            </thead>
            <tbody>
              {memberRep?.map((item, index) => (
                <tr style={{ borderBottom: "1px solid #ddd" }} key={index}>
                  <td className="padding10-td" style={{ textAlign: "center" }}>
                    {item.id}
                  </td>
                  <td className="padding10-td" style={{ textAlign: "center" }}>
                    {item.meeting_mt_num}
                  </td>
                  <td className="padding10-td" style={{ textAlign: "center" }}>
                    {item.meeting_date}
                  </td>

                  <td className="padding10-td" style={{ textAlign: "center" }}>
                    {item.mekhraz_num}
                  </td>
                  <td className="padding10-td" style={{ textAlign: "center" }}>
                    {item.mekhraz_title}
                  </td>
                  <td className="padding10-td" style={{ textAlign: "center" }}>
                    {item.member_role}
                  </td>
                  <td className="padding10-td" style={{ textAlign: "center" }}>
                    {item.attend ? "כן" : "לא"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div>
            <br />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "black",
            fontWeight: "bold",
          }}
        >
          {memberRep?.length === 0 && (
            <p
              style={{
                color: "blue",
                fontWeight: "bold",
                fontSize: "20px",
                textDecoration: "underline",
              }}
            >
              לא קיימות הצעות למועמד{" "}
            </p>
          )}
        </div>
      </div>
      <br />
    </div>
  );
};

export default MemberRep;
